<ion-button *ngIf="!isLoadingFollow && canUnfollow" (click)="unfollow()">
    <ion-icon slot="icon-only" name="notifications"></ion-icon>
</ion-button>
<ion-button *ngIf="!isLoadingFollow && !canUnfollow" (click)="follow()">
    <ion-icon slot="icon-only" name="notifications-outline"></ion-icon>
</ion-button>